import React, { lazy } from 'react';
import { createRoot } from 'react-dom/client';
import type { IPersonalJumbotronProps } from './personal-jumbotron';

const PersonalJumbotron = lazy(async () => import('./personal-jumbotron'));

const el = '.fa-component--personal-jumbotron';
const DOM = document.querySelectorAll(el);

const render = function () {
    if (DOM) {
        DOM.forEach((component) => {
            const props = JSON.parse(component.getAttribute('data-props') ?? '{}') as IPersonalJumbotronProps;

            createRoot(component).render(<PersonalJumbotron {...props} />);
        });
    }
};

export default {
    render,
};
